import { get, put } from './client';
import { buildPath, toJson } from './utils';
import { ADMIN_ORGANIZATIONS_PATH, API_GENERAL_PATH } from './constants';
import { IdType } from '../store/entities/types';

const SETTINGS = 'settings';
const CHECK_RECAPTCHA = 'check-recaptcha';
const UPDATE_EVENTS_RECAPTCHA = 'update-events-recaptcha';

export const checkRecaptcha = (options: any) => get(buildPath(API_GENERAL_PATH, CHECK_RECAPTCHA), options).then(toJson);

export const updateAdminOrganizationEventsReCaptcha = (orgId: IdType, options: any) =>
  put(buildPath(ADMIN_ORGANIZATIONS_PATH, orgId, SETTINGS, UPDATE_EVENTS_RECAPTCHA), options).then(toJson);
